import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Navbar from './components/Navbar';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Customers from './pages/Customers';
import Suppliers from './pages/Suppliers';
import Invoices from './pages/Invoices';
import Purchases from './pages/Purchases';
import POS from './pages/POS';
import Returns from './pages/Returns';
import Cash from './pages/Cash';
import OnlineBook from './pages/OnlineBook';
import Expenses from './pages/Expenses';
import Staff from './pages/Staff';
import Inventory from './pages/Inventory';
import Combos from './pages/Combos';
import Orders from './pages/Orders';
import Reports from './pages/Reports';
import CustomerReport from './pages/CustomerReport';
import GstReport from './pages/GstReport';
import SupplierReport from './pages/SupplierReport';
import Categories from './pages/Categories';
import Subcategories from './pages/Subcategories';
import ClientManagement from './pages/admin/ClientManagement';
import UserManagement from './pages/admin/UserManagement';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/products"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Products />
                </AdminRoute>
              }
            />
            <Route
              path="/categories"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Categories />
                </AdminRoute>
              }
            />
            <Route
              path="/subcategories"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Subcategories />
                </AdminRoute>
              }
            />
            <Route
              path="/customers"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Customers />
                </AdminRoute>
              }
            />
            <Route
              path="/suppliers"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Suppliers />
                </AdminRoute>
              }
            />
            <Route
              path="/purchases"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Purchases />
                </AdminRoute>
              }
            />
            <Route
              path="/combos"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Combos />
                </AdminRoute>
              }
            />
            <Route
              path="/orders"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Orders />
                </AdminRoute>
              }
            />
            <Route
              path="/inventory"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Inventory />
                </AdminRoute>
              }
            />
            <Route
              path="/invoices"
              element={
                <PrivateRoute>
                  <Invoices />
                </PrivateRoute>
              }
            />
            <Route
              path="/pos"
              element={
                <PrivateRoute>
                  <POS />
                </PrivateRoute>
              }
            />
            <Route
              path="/returns"
              element={
                <PrivateRoute>
                  <Returns />
                </PrivateRoute>
              }
            />
            <Route
              path="/cash"
              element={
                <PrivateRoute>
                  <Cash />
                </PrivateRoute>
              }
            />
            <Route
              path="/online-book"
              element={
                <PrivateRoute>
                  <OnlineBook />
                </PrivateRoute>
              }
            />
            <Route
              path="/expenses"
              element={
                <PrivateRoute>
                  <Expenses />
                </PrivateRoute>
              }
            />
            <Route
              path="/staff"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <Staff />
                </AdminRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <PrivateRoute>
                  <Reports />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/customers"
              element={
                <PrivateRoute>
                  <CustomerReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/gst"
              element={
                <PrivateRoute>
                  <GstReport />
                </PrivateRoute>
              }
            />
            <Route
              path="/reports/suppliers"
              element={
                <AdminRoute allowedRoles={['super_admin', 'admin']}>
                  <SupplierReport />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/clients"
              element={
                <AdminRoute allowedRoles={['super_admin']}>
                  <ClientManagement />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/users"
              element={
                <PrivateRoute>
                  <UserManagement />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
